export const TOURS = {
  agent: {
    id: "agent",
    title: "Agent Guided Tour",
    duration: "About 15 minutes",
    sections: [
      {
        id: "home",
        nav: "Home",
        title: "Welcome to the Agent tour",
        pointer: "Start at the quiet home chooser — Buyer Journey and Seller Journey stay apart.",
        script:
          "Welcome. This tour walks the agent desk at an unhurried pace. You will see how checklists, clients, and messages sit together without turning the work into a race.",
      },
      {
        id: "login",
        nav: "Agent login",
        title: "Signing in",
        pointer: "Use Agent login. Your broker and office are already part of the account.",
        script:
          "Sign in on the agent path. New agents enter their supervising broker and office. That keeps every file inside the right brokerage.",
      },
      {
        id: "dashboard",
        nav: "Agent Dashboard",
        title: "Your dashboard",
        pointer: "Open the dashboard snapshot: buyers, assigned files, upcoming tasks, unread notes.",
        script:
          "The dashboard is a snapshot, not a scoreboard. Active buyers, assigned files, upcoming calendar tasks, and unread notes live here. Seller files are labeled seller. They never mix with buyer checklists.",
      },
      {
        id: "checklists",
        nav: "Checklists",
        title: "Creating and walking checklists",
        pointer: "Client manager holds buyer progress. Seller portfolios stay on the seller path.",
        script:
          "You do not invent a second checklist engine. Buyers walk their DreamHome steps. Sellers assemble a portfolio. You follow along, respond, and keep the conversation useful.",
      },
      {
        id: "linking",
        nav: "Buyer / Seller",
        title: "Linking clients",
        pointer: "Each client names their agent, broker, and office when they create an account.",
        script:
          "Buyer and seller accounts stay free. They link to you, your broker, and the office. Messaging files follow those links, so supervision stays clear.",
      },
      {
        id: "messaging",
        nav: "Messaging",
        title: "Notes with clients and your broker",
        pointer: "Messages is a calm desk. You can attach a file saved on this device.",
        script:
          "Send a quiet note. Attach a document if you need to. Threads can be set aside. Closing a file saves a communication report. This is a companion, not a marketplace inbox.",
      },
      {
        id: "archive",
        nav: "Archive",
        title: "Archiving a file",
        pointer: "Close file from the desk. Broker and agent always receive the report flags.",
        script:
          "When the work is complete, or when it did not complete, archive the file. A report is saved first. Nothing is deleted. Retention stays available for the office.",
      },
    ],
  },
  broker: {
    id: "broker",
    title: "Broker Guided Tour",
    duration: "About 15 minutes",
    sections: [
      {
        id: "office",
        nav: "Broker Dashboard",
        title: "Office overview",
        pointer: "Office is the broker home — agents, open files, and a calm billing card.",
        script:
          "Welcome. The broker desk begins at Office, not in the inbox. You see agents in this brokerage, open and archived files, and unread notes without noise.",
      },
      {
        id: "agents",
        nav: "Agents",
        title: "Your agents",
        pointer: "The roster lists agents linked to this office and their plan status.",
        script:
          "Seat plans are up to twenty, up to fifty, or unlimited. If the office is over a seat count, you will see a calm notice. Limits apply when billing is connected. Work can continue.",
      },
      {
        id: "compliance",
        nav: "Compliance",
        title: "Retention and supervision",
        pointer: "Open Retention for the activity log. It is not a DRE certification.",
        script:
          "The retention log records notes, reports, archive, and status changes. It is a supervision record aligned with retention practice. It does not claim California DRE certification.",
      },
      {
        id: "reporting",
        nav: "Reporting",
        title: "Reports from a file",
        pointer: "From a conversation, Save report keeps JSON, HTML, and a woodland PDF.",
        script:
          "Each file can leave with a communication report: timeline, messages, attachments, and a checklist summary. Brokers and agents receive archive notices. Clients receive a copy only if they opted in.",
      },
      {
        id: "billing",
        nav: "Billing",
        title: "Billing without turning the app into a store",
        pointer: "Manage billing returns here, to dreamhomejourney.online, then back to the app.",
        script:
          "Payment lives on this site, not inside the checklist app. After a successful checkout you return to REChecklist. The workflow stays a decision companion.",
      },
    ],
  },
};

export function tourForRole(role) {
  if (role === "broker") return TOURS.broker;
  return TOURS.agent;
}

export const SIDEBAR_ORDER = [
  "Home",
  "Agent Dashboard",
  "Broker Dashboard",
  "Buyer / Seller",
  "Checklists",
  "Messaging",
  "Compliance",
  "Archive",
];
